<template>
    <div>
        <div class="widget widget-filters--offcanvas--mobile-bg-color" data-collapse data-collapse-opened-class="filter--opened" v-if="standardItems.length > 0">
            <div class="widget-filters__list">
                <div class="widget-filters__item">
                    <div class="filter filter--closed" :class="(collapsed) ? 'filter--opened' : ''">
                        <button type="button" class="filter__title" @click="collapsed=!collapsed">
                            PRODUCTS ORDERED (Click to Expand)
                            <span class="filter__arrow">
                                <svg width="12px" height="7px">
                                    <path d="M0.286,0.273 L0.286,0.273 C-0.070,0.629 -0.075,1.204 0.276,1.565 L5.516,6.993 L10.757,1.565 C11.108,1.204 11.103,0.629 10.747,0.273 L10.747,0.273 C10.385,-0.089 9.796,-0.086 9.437,0.279 L5.516,4.296 L1.596,0.279 C1.237,-0.086 0.648,-0.089 0.286,0.273 Z" />
                                </svg>
                            </span>
                        </button>
                        <div class="filter__body" data-collapse-content>
                            <div class="filter__container">
                                <div class="block-space--layout--divider-15"></div>
                                <table class="checkout__totals" v-if="standardItems.length > 0">
                                    <thead class="checkout__totals-header">
                                        <tr>
                                            <th>Item</th>
                                            <th>Qty</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody class="checkout__totals-products">
                                        <tr v-for="item in standardItems" :key="item.linenumber">
                                            <td>
                                                <strong>{{ item.desc }} </strong>
                                                <br />
                                                <small class="mr-4" v-if="item.XRITMC">Item: {{ item.XRITMC }} <span >({{item.item}})</span> </small>
                                                <small class="mr-4" v-else >Item: {{ item.item }}</small>
                                                <small>MFR: {{ item.manufacturer }}</smalL>
                                            </td>
                                            <td>
                                                {{ item.quantity }}
                                            </td>
                                            <td class='notranslate'>
                                                {{ toUSD(item.linetotal) }}
                                            </td>
                                        </tr>
                                        <!-- <order-item 
                                            v-for="(item, indx) in cart"
                                            :key="item.ID"
                                            :index="indx"
                                            :orderedItem="item">
                                        </order-item> -->
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div v-for="(kit, index) in lkits" :key="index">
            <div class="widget widget-filters--offcanvas--mobile-bg-color" data-collapse data-collapse-opened-class="filter--opened" v-if="kits.length > 0">
                <div class="widget-filters__list">
                    <div class="widget-filters__item">
                        <div class="filter filter--closed" :class="(kit.collapsed) ? 'filter--opened' : ''">
                            <button type="button" class="filter__title" @click="kit.collapsed = !kit.collapsed">
                                {{kit.kitnumber}} (Click to Expand)
                                <span class="filter__arrow"><svg width="12px" height="7px">
                                        <path d="M0.286,0.273 L0.286,0.273 C-0.070,0.629 -0.075,1.204 0.276,1.565 L5.516,6.993 L10.757,1.565 C11.108,1.204 11.103,0.629 10.747,0.273 L10.747,0.273 C10.385,-0.089 9.796,-0.086 9.437,0.279 L5.516,4.296 L1.596,0.279 C1.237,-0.086 0.648,-0.089 0.286,0.273 Z" />
                                    </svg></span>
                            </button>
                            <div class="filter__body" data-collapse-content>
                                <div class="filter__container">
                                    <div class="block-space--layout--divider-15"></div>
                                    <table class="checkout__totals" v-if="kits.length > 0">
                                        <thead class="checkout__totals-header">
                                            <tr>
                                                <div class="kit-code-header"><h6>Engine Rebuild Kit - {{kit.kitnumber}}</h6></div>
                                                <div class="kit-code-subheader"><p>Kit Code: {{kit.kitnumber}}</p></div>
                                            </tr>
                                            <tr>
                                                <th>Item</th>
                                                <th>Qty</th>
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody class="checkout__totals-products">
                                            <tr v-for="item in kit.kit_items" :key="item.linenumber">
                                                <td>
                                                    <strong>{{ item.desc }} </strong>
                                                    <br />
                                                    <small class="">Item: {{ item.item }} <span v-if="item.XRITMC">({{item.XRITMC}})</span> </small>
                                                    <small style="margin-left: 5px" v-if="item.origItem">ALTERNATE for Item: {{item.origItem}}</small>
                                                    <small  style="margin-left: 5px">MFR: {{ item.manufacturer }}</smalL>
                                                </td>
                                                <td>
                                                    {{ item.quantity }}
                                                </td>
                                                <td class='notranslate'>
                                                    {{ toUSD(item.linetotal) }}
                                                </td>
                                            </tr>
                                            <!-- <order-item 
                                                v-for="(item, indx) in cart"
                                                :key="item.ID"
                                                :index="indx"
                                                :orderedItem="item">
                                            </order-item> -->
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Price from '../../../mixins/price.js';
// import OrderItem from './OrderItem.vue'

export default {
    // components: {
    //     OrderItem
    // },
    props: {
        currentlocationid: {
            type: String,
            required: false
        },
        isCartItems: {
            type: Boolean,
            required: false,
        }
    },
    mixins: [
        Price
    ],
    data() {
        return {
            collapsed : false,
        }
    },
    computed: {
		...mapGetters([
            "getDefaultLocationDetails"
        ]),
        ...mapGetters("cart", [
            "cart",
            "totals",
            "kits",
        ]),
        standardItems() {
            if (this.isCartItems){
                const items = this.cart.filter(item => (item.backorder == '' || item.backorder === false || item.backorder == undefined));
                return items;
            }

            return this.cart.filter(item => {
                if (this.currentlocationid === this.getDefaultLocationDetails.defaultlocationid) {
                    return (item.locationid === undefined || item.locationid === this.currentlocationid) && !item.backorder;
                } else {
                    return (item.locationid === this.currentlocationid) && !item.backorder;
                }
            })
        },

        cartItems() {
            return this.cart.filter(item => (item.backorder === '' || item.backorder === false));            
        },

        lkits() {
            // console.table('currentlocationid = ' + this.currentlocationid);
            console.log(this.kits);
            
            if(this.currentlocationid == undefined){
                return this.kits;
            }
            // console.table(this.kits);
            const kits = this.kits.filter(item => {
                // console.log(item);
                if (this.currentlocationid === this.getDefaultLocationDetails.defaultlocationid) {
                    return (item.locationid === undefined || item.locationid === this.currentlocationid);
                } else {
                    return (item.locationid === this.currentlocationid);
                }
            });
            
            kits.forEach(k => {
                k.collapsed = false;
            });

            return kits;
        }
        
    },
    methods: {
        collapse() {

        },
    },

    created() {
        // console.log("Products ordered- created");
        // console.log(this.standardItems);
    }
}
</script>